import { render, staticRenderFns } from "./MainSkuImg.vue?vue&type=template&id=93a18b46&scoped=true"
import script from "./MainSkuImg.vue?vue&type=script&lang=js"
export * from "./MainSkuImg.vue?vue&type=script&lang=js"
import style0 from "./MainSkuImg.vue?vue&type=style&index=0&id=93a18b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a18b46",
  null
  
)

export default component.exports